import { Card, Typography } from "antd";
import styled from "styled-components";

const { Title } = Typography;

export const StyledHeaderImage = styled.img`
  width: 100%; /* Kan brukes for å croppe bildet */
  height: 100%; /* Kan brukes å croppe bildet */
  display: block;
  object-fit: cover;
  object-position: center center;
`;

export const StyleHeaderImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  max-height: 400px; /* Må kanskje justeres ut i fra bildet */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledDiv = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledCardWrapper = styled(Card)`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: var(--neutral);
  padding: 0em 3em;
  height: 80px;
  .ant-card-body {
    padding: 18px;
    height: 100%;
    box-sizing: border-box;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  width: 95%;
  max-width: 400px;
`;

export const StyledTitle = styled(Title)`
  white-space: nowrap;
  margin: 0 !important;
  font-size: 2px;
`;
